import { render, staticRenderFns } from "./galeria.vue?vue&type=template&id=ecb3acb4&"
import script from "./galeria.vue?vue&type=script&lang=js&"
export * from "./galeria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports